<template>
  <div
    id="employee-table"
    class="list-data-table">

    <!-- HEADER SECTION -->
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header"
      style="padding-bottom: 0 !important; padding-top: 15px !important; height: 110px">
      <div class="title-tab-experience-manager">ADMINISTRATOR</div>
      <div class="d-flex m__t--45">
        <template v-for="(tab, index) in tabMenu">
          <div
            v-if="tab.show"
            :key="tab.label"
            :class="[
              { 'm__r--35': index < tabMenu.length - 1 },
              tab.active ? 'tab-experience-manager-active' : 'tab-experience-manager'
            ]"
            @click="$router.replace(tab.url)"
          >
            {{ tab.label }}
          </div>
        </template>
      </div>
    </div>

    <router-view/>
    <!-- <j-progress-screen
      ref="progressScreen"
      :data-kirim="import_data"
      :url-api="url"
      :headers="headers"
      property-data="data"
      @finish="reloadTable"/>
    <j-progress-screen-multi-url
      ref="progressScreenMultiUrl"
      :data-kirim="import_data"
      :url-api="urls"
      :headers="headers"
      @finish="reloadTable"/>
    <b-modal
      ref="confirmationGenerate"
      title="Confirmation">
      <br>
      <br>
      <center>
        <label class="m__l--20 m__r--20 msg">
          We will generate Employee Data.
          Generate Employee Data will take few minutes.
          We will inform you if the data is ready.
        </label>
      </center>
      <br>
      <br>
      <template slot="modal-footer">
        <div class="w-100">
          <b-button
            class="btn gray float-left"
            @click="$refs.confirmationGenerate.hide()">
            Cancel
          </b-button>
          <b-button
            class="btn blue float-right"
            @click="onClickConfirmToGenerateEmployeeData">
            Notify me via email
          </b-button>
        </div>
      </template>
    </b-modal>

    <div
      v-show="false"
      class="row"
    >
      <div class="col-6 p__t--27">
        <b-button
          class="btn green outline import-employee__btn"
          @click="showDateExport()"> Export Employee Historical </b-button>
        <b-button
          class="btn green outline"
          @click="exportEmployeeData"> Generate Employee Data </b-button>
      </div>
      <div class="col-6"/>
      <div class="col-6">
        <div
          v-show="false"
          class="row"
        >
          <div
            v-if="is_import_employee"
            class="col-5">
            <label>Import Type</label>
            <j-select
              v-model="import_type"
              :options="import_type_options"/>
          </div>
          <div
            v-else
            class="col-3"/>
          <div
            v-if="is_import_employee"
            class="col-7">
            <label class="float-right">
              <i
                class="fa fa-times c--red close-btn"
                @click="closeImportEmployee"/>
            </label>
            <j-import-button
              v-if="import_type"
              :type="import_type"
              @setInvalidHeader="setInvalidHeader"
              @onClickDownload="onClickDownload"
              @onClickImportFile="onClickImportFile"
              @importData="importData"/>
          </div>
          <div
            v-else
            class="col-9 p__t--27">
            <b-button
              v-if="!is_import_employee"
              class="btn blue float-right m__r--10"
              @click="is_import_employee = true">
              Import Employee
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div
      v-show="date_export">
      <b-row>
        <b-col cols="3">
          <b-form-group :class="{'error-input' : $v.export_data_xls.start_date.$error}">
            <label>From</label>
            <j-datepicker
              v-model="$v.export_data_xls.start_date.$model"
              :disabled-dates="from_date_disabled"
              :disabled="false"
              format="MMM dd, yyyy"
              placeholder="Jan 01, 2019"/>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group :class="{'error-input' : $v.export_data_xls.end_date.$error}">

            <label>To</label>
            <j-datepicker
              v-model="$v.export_data_xls.end_date.$model"
              :disabled-dates="end_date_disabled"
              :disabled="false"
              class=""
              format="MMM dd, yyyy"
              placeholder="Jan 01, 2019"/>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-button
            style="height:35px"
            class="btn blue outline import-employee__btn m__t--27"
            @click="exportEmployeeHistorical"> Export </b-button>
        </b-col>
      </b-row>
    </div> -->

    <!-- CONTENT SECTION -->
    <div class="studio-page-administrator-content">
      <v-server-table
        v-show="load_first"
        ref="employeeServer"
        :columns="columns"
        :options="options"
        class="jTable studio-table"
        @loading="loading"
        @loaded="loaded"
        @row-click="rowClick">

        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form inline>
            <b-button
              class="btn grey btn-import-oos m__r--5"
              @click="$router.replace('/administrator/create')">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
            <!-- <b-button
                class="btn grey btn-import-oos m__r--5">
                <i class="fa fa-cloud-upload fa-lg"/> Import
              </b-button> -->
            <!-- <b-button
                id="table-search"
                class="btn grey btn-import-oos">
                <i class="fa fa-search fa-lg"/> Search
              </b-button> -->
            <b-form
              inline
              @keypress.13.prevent="filter(filter_data)">
              <j-select
                v-model="select_type"
                :options="options_search"
                :error-required="false"
                placeholder="Filter By"
                class="m__r--5"/>
              <b-form-input
                ref="filterInput"
                v-model="filter_data"
                placeholder="Search"
                style="width: 250px; height: 35px"/>
            </b-form>
          </b-form>
        </div>

        <div
          slot="staff_name"
          slot-scope="props">
          <div v-if="props.row.profile">
            <div class="td">
              <b-img
                v-if="props.row.profile.photo_url"
                :src="props.row.profile.photo_url"
                rounded="circle"
                alt="img"
                class="m-1 round-bordered-img
                img-circle staff-img image-popup-link b-page-theme td"/>
              <b-img
                v-else
                :src="require('../../assets/logo/user1.png')"
                rounded="circle"
                alt="img"
                class="m-1 round-bordered-img
                img-circle staff-img image-popup-link b-page-theme td"/>
            </div>
            <div class="td p__t--7">
              <div>{{ props.row.email }}</div>
              <div>{{ props.row.profile.first_name }} {{ props.row.profile.last_name }}</div>
            </div>
          </div>
          <div v-else>
            {{ props.row.email }}
          </div>
        </div>

        <div
          slot="user_id"
          slot-scope="props"
        >
          {{ props.row.profile && props.row.profile.user_id ? props.row.profile.user_id : '-' }}
        </div>

        <div
          slot="user_company_id"
          slot-scope="props"
        >
          {{ props.row.profile && props.row.profile.user_company_id ?
          props.row.profile.user_company_id : '-' }}
        </div>

        <div
          slot="role"
          slot-scope="props"
          style="width: 150px;"
        >
          <div v-if="props.row.profile">
            <span
              v-if="props.row.profile.user_role"
              class="roles-text">
              {{ convertRole(props.row.profile.user_role) }}
            </span>
          </div>
        </div>

        <div
          slot="is_active"
          slot-scope="props"
        >
          <div
            :class="props.row.is_active ? 'status-on' : 'status-off'"
            class="status-user"
          >
            <div class="circle-accent" />
            <span>{{ props.row.is_active ? 'ON' : 'OFF' }}</span>
          </div>
        </div>

        <div
          slot="created_date"
          slot-scope="props"
        >
          {{ formatDateToLocal(props.row.created_date) }}
        </div>

        <div
          slot="updated_date"
          slot-scope="props"
        >
          {{ props.row.updated_date | moment("YYYY-MM-DD HH:mm:ss") }}
        </div>

      </v-server-table>

      <div>
        <jLoadingTable v-if="!load_first"/>
      </div>
    </div>

    <b-popover
      ref="searchFormModal"
      :show.sync="popoverSearchShow"
      triggers="click"
      container="employee-table"
      target="table-search"
      placement="right">
      <div class="m__b--10">Search Data</div>
      <b-form
        inline
        @keypress.13.prevent="filter(filter_data)">
        <j-select
          v-model="select_type"
          :disabled="false"
          :options="options_search"
          class="m__r--5"/>
        <j-input
          v-model="filter_data"
          placeholder="Search"
          class="m__r--5"/>
        <b-button
          class="btn blue outline"
          style="margin-top: -19px;"
          @click="filter(filter_data)">
          <i class="fa fa-search bold" /> Search
        </b-button>
      </b-form>
    </b-popover>

  </div>
</template>

<script>
/* eslint-disable vue/name-property-casing */
/* eslint-disable import/no-duplicates,import/prefer-default-export,object-shorthand */
/* eslint-disable no-unused-expressions,no-unused-vars,key-spacing */

import { mapActions, mapState } from 'vuex';
import Vue from 'vue';
import jApi from '@/services/jApi';
import jApiEmployee from '@/services/jApiEmployee';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jImportButton from '@/components/import/buttons/jImportEmployeeButton';
import jProgressScreenMultiUrl from '@/components/progress-screen/jProgressScreen';
import { required } from 'vuelidate/lib/validators';
import Constant from '@/utils/constant';

export default {
  name: 'jEmployeeList',
  components: {
    jLoadingTable,
    jImportButton,
    jProgressScreenMultiUrl,
  },
  data() {
    return {
      popoverSearchShow: false,
      export_data_xls: {
        start_date: '',
        end_date: '',
        type: 'xls',
      },
      datepicker: '',
      from_date_disabled: {
        color: 'light-grey',
        ranges: [{
          from: '',
          to: '',
        }],
      },
      end_date_disabled: {
        color: 'light-grey',
        ranges: [{
          from: '',
          to: '',
        }],
      },
      date_export: false,
      options_head: {
        icon: 'fa-user',
        main_title: 'Employee',
        opt_title: '',
      },
      filter_data: '',
      select_type: 'staff_name',
      options_search: [
        {
          text: 'Name',
          value: 'staff_name',
        },
        {
          text: 'Email',
          value: 'email',
        },
      ],
      import_type_options: [
        {
          text: 'Personal Data',
          value: 'personal_data',
        },
        {
          text: 'Employee Documents',
          value: 'employee_documents',
        },
        {
          text: 'Family & Relations',
          value: 'family_and_relations',
        },
        {
          text: 'Emergency Contacts',
          value: 'emergency_contacts',
        },
        {
          text: 'Business Line',
          value: 'business_line',
        },
        {
          text: 'Medical Information',
          value: 'medical_information',
        },
        {
          text: 'Medical Records',
          value: 'medical_records',
        },
        {
          text: 'Careers',
          value: 'careers',
        },
        {
          text: 'Education',
          value: 'education',
        },
        {
          text: 'Self Developments',
          value: 'self_developments',
        },
        {
          text: 'Track Records',
          value: 'track_records',
        },
        {
          text: 'Payroll Data',
          value: 'payroll_data',
        },
      ],
      import_type: null,
      is_import_employee: false,
      url: null,
      urls: [],
      headers: null,
      import_data: [],
      data_table: [],
      selected_rows: [],
      load_first: false,
      columns: ['staff_name', 'user_id', 'user_company_id', 'role', 'is_active', 'created_date', 'updated_date'],
      options: {
        headings: {
          user_id: 'USER ID',
          user_company_id: 'USER COMPANY ID',
          staff_name: 'NAME',
          role: 'ROLE',
          is_active: 'ACTIVE',
          created_date: 'CREATED DATE',
          updated_date: 'UPDATED DATE',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: ['user_id', 'user_company_id', 'staff_name', 'roles', 'created_date', 'updated_date'],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            pagination: {
              limit: data.limit,
              page: data.page,
              column: data.orderBy ? data.orderBy : 'id',
              ascending: !data.ascending,
              query: data.query ? data.query : '',
              query_type: data.query_type ? data.query_type : '',
            },
          };
        },
        requestFunction(data) {
          const getListEmployee = jApiEmployee.listEmployee(data);
          return getListEmployee.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/toggleProblem', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length !== undefined ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
    ...mapState('jStoreEmployee', ['employee_created']),
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
    ...mapState('jStoreLogin', ['profile_data']),

    role() {
      return Number(localStorage.getItem('userRole') || this.profile_data.userRole);
    },

    tabMenu() {
      return [
        { url: '/administrator', label: 'USER', show: true, active: true },
        { url: '/administrator/position', label: 'POSITION', show: true, active: false },
        { url: '/administrator/unit', label: 'UNIT', show: true, active: false },
        { url: '/administrator/location', label: 'LOCATION', show: true, active: false },
        { url: '/administrator/layer', label: 'LAYER', show: true, active: false },
        { url: '/administrator/company/profile', label: 'COMPANY', show: true, active: false },
        { url: '/administrator/company/settings', label: 'SETTINGS', show: this.role === 1, active: false },
      ];
    },
  },
  watch: {
    employee_created() {
      this.$refs.employeeServer.getData();
    },

    filter_data(val) {
      if (val === '') {
        this.$refs.employeeServer.setFilter('');
      }
    },
    selected_rows() {
      if (this.selected_rows.length === 0) {
        this.$refs.floating.hide();
      } else {
        this.$refs.floating.show();
      }
    },
    // eslint-disable-next-line func-names
    'export_data_xls.start_date': function (date) {
      if (this.export_data_xls.end_date !== '') {
        if (this.export_data_xls.end_date < date) {
          this.export_data_xls.end_date = date;
        }
      }
      this.restrictDate(date, 'from');
    },
    // eslint-disable-next-line func-names
    'export_data_xls.end_date': function (date) {
      if (this.export_data_xls.start_date !== '') {
        if (this.export_data_xls.start_date > date) {
          this.export_data_xls.start_date = date;
          this.restrictDate(date, 'end');
        }
      }
    },
    load_first(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.filterInput.focus();
        }, 200);
      }
    },
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'toggleSuccess', 'showLoading', 'hideLoading']),
    ...mapActions('jStoreImport', ['onSetInvalidHeaderList']),

    loading(val) {
      const a = val;
      a.pagination.query_type = this.select_type;
      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;
      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    refreshTable() {
      this.$refs.employeeServer.getData();
    },

    filter(val) {
      this.$refs.employeeServer.setFilter(val);
    },

    rowClick(data) {
      this.$router.push(`/administrator/detail/${data.row.id}`);
    },
    showDateExport() {
      this.date_export = !this.date_export;
    },
    exportEmployeeData() {
      this.$refs.confirmationGenerate.show();
    },
    showImportEmployeeModal() {
      this.$refs.importEmployeeModal.show();
    },
    closeImportEmployee() {
      this.is_import_employee = false;
      this.import_type = null;
    },
    onClickConfirmToGenerateEmployeeData() {
      this.showLoading();
      const api = jApi.generateApi();
      return api.get('user/employees?q=export_email&format=xlsx')
        .then(res => res.data)
        .then(() => {
          this.hideLoading();
          this.toggleSuccess('Success request generate employee data');
        })
        .catch((err) => {
          this.hideLoading();
          this.toggleProblem('Something is wrong, please try again');
        });
    },
    onClickDownload() {
      const link = document.createElement('a');
      link.href = 'https://jojonomic-frontend.s3-ap-southeast-1.amazonaws.com/static/file/import/example/employee/Template+Import+Employee.zip';
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    setInvalidHeader(xlsHeader) {
      const validateHeader = xlsHeader.filter(header =>
        header.includes('allowance__') || header.includes('deduction__'));
      this.onSetInvalidHeaderList(validateHeader.filter(
        header => !this.headerValidationList.includes(header),
      ));
    },
    onClickImportFile() {
      // do nothing
    },
    importData(data) {
      if (data.body.length === 0) {
        this.toggleProblem('No data selected');
      } else {
        const token = Vue.ls.get('Token');
        this.headers = {
          Authorization: token,
        };
        this.url = null;
        this.urls = [];
        if (this.import_type === 'personal_data') {
          this.url = `${process.env.GATE_URL}user/user/create`;
          this.import_data = data.body.map((element) => {
            const item = element;
            const roles = element.roles.split(',');
            item.roles = [...roles];
            item.id = 0;
            item.root_id = -1;
            return item;
          });
        } else if (this.import_type === 'business_line') {
          this.import_data = data.body.map((element) => {
            const coManagers = element['business_lines__co-managers'].split(',');
            const item = {
              id: 0,
              root_id: -1,
              main: element.business_lines__main,
              sub: element.business_lines__sub,
              co_managers: [
                {
                  name: coManagers[0],
                },
                {
                  name: coManagers[1],
                },
              ],
            };
            const url = `${process.env.GATE_URL}hris-references-service/employees/${element.email}/business_lines`;
            this.urls.push(url);
            return item;
          });
        }
        this.$nextTick(() => {
          this.showProgressScreen();
        });
      }
    },
    showProgressScreen() {
      if (this.import_type === 'personal_data') {
        this.$refs.progressScreen.toggleIsVisible();
      } else {
        this.$refs.progressScreenMultiUrl.toggleIsVisible();
      }
    },
    reloadTable() {
      this.$refs.employeeServer.getData();
      this.$nextTick(() => {
        this.closeImportEmployee();
      });
    },
    fileDownload(response) {
      window.location.href = response;
    },
    exportEmployeeHistorical() {
      this.$v.export_data_xls.$touch();
      if (!this.$v.export_data_xls.$error) {
        const api = jApi.generateApi();
        const req = {
          start_date: this.$moment(this.export_data_xls.start_date).format('YYYY-MM-DD'),
          end_date: this.$moment(this.export_data_xls.end_date).format('YYYY-MM-DD'),
          type: 'xls',
        };
        return api.post('hris-historical/report/export', req)
          .then(res => res.data)
          .then(obj => this.fileDownload(obj.data.url, obj.data.file_name));
      }
      return null;
    },
    restrictDate(e, status) {
      if (status === 'from') {
        this.end_date_disabled.ranges = [{
          from: new Date(1, 1, 1),
          to: this.export_data_xls.start_date,
        }];
      }
      if (status === 'end') {
        this.from_date_disabled.ranges = [{
          from: this.export_data_xls.start_date,
          to: new Date(100000, 100000, 100000),
        }];
      }
    },
    // eslint-disable-next-line
    convertRole(roleId) {
      if (roleId === Constant.RoleAdmin) return 'ADMIN';
      if (roleId === Constant.RoleImplementor) return 'IMPLEMENTOR';
      if (roleId === Constant.RoleUser) return 'USER';
    },
    formatDateToLocal(dateStr) {
      const date = new Date(`${dateStr}Z`);
      const pad = n => String(n).padStart(2, '0');

      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
  },
  validations: {
    export_data_xls: {
      start_date: { required },
      end_date: { required },
    },
  },
};
</script>

<style lang="scss">
  #employee-table {
    z-index: 1;
  }

  .msg {
    font-size: 17px;
    white-space: pre-line;
  }
  .close-btn {
    cursor: pointer;
    font-weight: 600;
  }

  .list-data-table .popover {
    max-width: 600px;
  }

  .roles-text {
    background-color: #E5ECFF;
    color: #1E5AFF;
    margin: 0 3px;
    padding: 4px;
    border-radius: 8px;
  }

  .status-user {
    width: min-content;
    display: flex;
    align-items: center;
    padding: 2px 6px;
    border-radius: 9999px;

    .circle-accent {
      width: 12px;
      height: 12px;
      margin-right: 4px;
      border-radius: 9999px;
    }
    span {
      @include font('Poppins-Semibold', 12px, $black);
    }

    &.status-on {
      background-color: #F0F8E5;

      .circle-accent {
        background-color: #61BC50;
      }
      span {
        color: #61BC50;
      }
    }
    &.status-off {
      background-color: #FFEBED;

      .circle-accent {
        background-color: #D0021B;
      }
      span {
        color: #D0021B;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/user-employee/jEmployeeList.vue